<template>
    <div id="activityLogsModal" class="modal fade" tabindex="-1">
        <div class="modal-dialog modal-xl">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="header-title mt-0">Activity Logs</h4>
                </div>
                <div class="modal-body pb-3">
                    <div class="d-flex justify-content-center" v-if="loading">
                        <Loading :show-text="false" spinner-class="spinner-grow"/>
                    </div>

                    <div class="row">
                        <div class="col-sm-12 col-md-6">
                            <label v-if="!loading" class="form-label text-nowrap">
                                Display
                                <select v-model="paginateParams.perPage"
                                        @change="loadActivityLogs()"
                                        :disabled="loading"
                                        class="form-select form-select-sm d-inline mx-1">
                                    <option :value="5">5</option>
                                    <option :value="10">10</option>
                                    <option :value="25">25</option>
                                    <option :value="50">50</option>
                                    <option :value="250">250</option>
                                </select>
                                activity logs
                            </label>
                        </div>
                        <div class="col-sm-12 col-md-6 text-md-end">
                            <div class="mb-2 mb-md-0 me-0 me-md-2 dropdown d-inline-block">
                                <button
                                    class="btn btn-light btn-sm dropdown-toggle"
                                    type="button"
                                    id="dropDownFilterActivityLogs"
                                    data-bs-toggle="dropdown"
                                    data-bs-auto-close="outside"
                                    aria-expanded="false"
                                >
                                    <SvgIcon
                                        type="mdi"
                                        :path="mdiFilter"
                                        style="max-width: 16px"
                                    ></SvgIcon>
                                    Filter
                                </button>
                                <div class="dropdown-menu px-4 py-3" style="min-width: 500px;" aria-describedby="dropDownFilterActivityLogs">
                                    <div class="mb-2 row">
                                        <div class="col-sm-6" style="min-width: 200px">
                                            <label for="date_from" class="form-label text-sm mb-1">From:</label>
                                            <input v-model="dateRange.from" @change="paginateParams.page = 1; loadActivityLogs()" type="date" id="date_from" class="form-control form-control-sm">
                                        </div>
                                        <div class="col-sm-6" style="min-width: 200px">
                                            <label for="date_to" class="form-label text-sm mb-1">Until:</label>
                                            <input v-model="dateRange.to" @change="paginateParams.page = 1; loadActivityLogs()" type="date" id="date_to" class="form-control form-control-sm">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <label class="form-label text-nowrap">
                                <div class="input-group input-group-sm">
                                    <input type="search"
                                           :disabled="loading"
                                           class="form-control form-control-sm"
                                           placeholder="Search activity logs"
                                           v-model="searchQuery"
                                    >
                                    <button
                                        :disabled="loading"
                                        class="btn btn-outline-secondary"
                                        type="button"
                                        @click="searchActivityLogs()"
                                    >
                                        <SvgIcon
                                            type="mdi"
                                            :path="mdiMagnify"
                                            style="width: 1.3em"
                                        ></SvgIcon>
                                    </button>
                                </div>
                            </label>
                        </div>
                    </div>

                    <div class="table-responsive" v-if="!loading">
                        <table class="table table-sm table-striped table-bordered">
                            <thead>
                            <tr>
                                <th class="col sortable"
                                    :class="{ 'sort-asc': paginateParams.sortBy === 'created_at' && paginateParams.sortDirection === 'asc', 'sort-desc': paginateParams.sortBy === 'created_at' && paginateParams.sortDirection === 'desc', }"
                                    role="button"
                                    @click="toggleSort('created_at')">Occured at
                                </th>
                                <th class="col sortable"
                                    :class="{ 'sort-asc': paginateParams.sortBy === 'event' && paginateParams.sortDirection === 'asc', 'sort-desc': paginateParams.sortBy === 'event' && paginateParams.sortDirection === 'desc', }"
                                    role="button"
                                    @click="toggleSort('event')">Event
                                </th>
                                <th style="white-space: nowrap">Caused by</th>
                                <th style="white-space: nowrap">Properties</th>
                            </tr>
                            </thead>
                            <tbody>
                            <template
                                v-for="(activityLog, key) in activityLogs ?? []" :key="activityLog?.id ?? key">
                                <tr>
                                    <td class="col">{{ DateTime.fromISO(activityLog.created_at ?? "").toLocaleString(DateTime.DATETIME_MED_WITH_WEEKDAY) }}</td>
                                    <td class="col"><span class="badge badge-pill" :class="`badge-${activityLog.event}`">{{ activityLog.event }}</span></td>
                                    <td class="col" v-if="activityLog.causer">{{ activityLog.causer?.name }} <span class="text-body-tertiary" v-if="activityLog.causer?.deleted_at">(Deleted user)</span></td>
                                    <td class="col text-secondary" v-else><em>Unknown or deleted user</em></td>
                                    <td class="col">
                                        <a href="javascript:void(0);" @click="propertiesModalActivityId = activityLog.id">
                                            View changes ({{ Object.keys(activityLog.properties.attributes ?? activityLog.properties ?? {}).length }})
                                        </a>
                                    </td>
                                </tr>
                            </template>
                            </tbody>
                        </table>
                    </div>
                    <Pagination
                        v-if="!loading"
                        record-name="activity logs"
                        store-name="ActivityLog"
                        @pageChanged="loadActivityLogs()"></Pagination>
                </div>
                <div class="modal-footer">
                    <Button class="btn btn-secondary" @click="show = false">
                        Close
                    </Button>
                </div>
            </div>
        </div>
    </div>
    <div id="activityLogsPropertiesModal" class="modal fade" tabindex="-1">
        <div class="modal-dialog modal-xl">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="header-title">Event: {{ selectedActivityLog?.event }}</h4>
                </div>
                <div class="modal-body">
                    <div class="table-responsive">
                        <template v-if="selectedActivityLog?.event === 'fare-recalculated'">
                            <table class="table table-sm table-bordered">
                                <thead class="table-light">
                                <tr>
                                    <th>Type</th>
                                    <th>Description</th>
                                    <th>creditType</th>
                                    <th>hasGst</th>
                                    <th class="text-end">Amount</th>
                                </tr>
                                </thead>
                                <tbody>
                                <template v-for="fare in selectedActivityLog?.properties ?? []">
                                    <tr>
                                        <td>{{ fare.type }}</td>
                                        <td>{{ fare.description }}</td>
                                        <td>{{ fare.creditType }}</td>
                                        <td>{{ fare.hasGst }}</td>
                                        <td>{{ formatCurrency(fare.amount.amount) }}</td>
                                    </tr>
                                </template>
                                </tbody>
                            </table>
                        </template>
                        <template v-else>
                            <table class="table table-sm table-bordered">
                                <thead class="table-light">
                                <tr>
                                    <th>Property</th>
                                    <th class="text-end">New</th>
                                    <th class="text-end">Old</th>
                                </tr>
                                </thead>
                                <tbody>
                                <template v-for="key in Object.keys(selectedActivityLog?.properties?.attributes ?? {}) ?? []">
                                    <ActivityLogPropertiesChangedRow
                                        :propertiesToShow="selectedActivityLog?.properties"
                                        :attribute="key"
                                    />
                                </template>
                                </tbody>
                            </table>
                        </template>
                    </div>
                    <div class="modal-footer">
                        <Button class="btn btn-secondary"
                                @click="propertiesModalActivityId = undefined">
                            Close
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped>

.badge-created {
    color: #216e52;
    background-color: rgba(66, 210, 157, 0.18);
}

.badge-deleted {
    color: #dc2626;
    background-color: rgba(220, 38, 38, 0.18);
}

.badge-updated {
    color: #26697c;
    background-color: rgba(68, 186, 220, 0.18);
}

.badge-fare-recalculated {
    color: #956e00;
    background-color: #f9bc0d2e;
}

th.sortable:before {
    top: 4px;
}

th.sortable:after {
    top: 10px;
}
</style>
<script setup lang="ts">
import ActivityLog, { ListActivityLogsRequestParameters } from "@classes/ActivityLog";
import { formatCurrency } from "@classes/Helpers/Currency";
import ActivityLogPropertiesChangedRow from "@components/ActivityLogsModalPlugin/ActivityLogPropertiesChangedRow.vue";
import Button from "@components/Button.vue";
import Loading from "@components/Loading.vue";
import Pagination from "@components/DataTable/Pagination.vue";
import { sortDirectionEnum } from "@customTypes/DataTableTypes";
import { PaginatedMetaInterface } from "@customTypes/LaravelCommonTypes";
import ActivityLogResource from "@customTypes/resources/ActivityLogResource";
import SvgIcon from "@jamescoyle/vue-icon";
import { mdiMagnify, mdiFilter } from "@mdi/js";
import { usePaginationStore } from "@stores/PaginationStore";
import { Modal } from "bootstrap";
import { DateTime } from "luxon";
import { storeToRefs } from "pinia";
import { computed, ComputedRef, inject, onMounted, Ref, ref, watch } from "vue";

const activityLogSubjectType = inject<any>("activityLogSubjectType");
const activityLogSubjectUuid = inject<any>("activityLogSubjectUuid");

const loading = ref(false);

//@ts-ignore
const listModal = ref<null | bootstrap.Modal>(null);
const propertiesModal = ref<null | bootstrap.Modal>(null);
const propertiesModalActivityId: Ref<number | undefined> = ref<number | undefined>();

const dateRange: Ref<{ from: string | null, to: string | null }> = ref({ from: null, to: null });
const { paginatedMeta, searchQuery, paginateParams } = storeToRefs(usePaginationStore('ActivityLog'));

const activityLogs: Ref<ActivityLogResource[] | undefined> = ref<ActivityLogResource[] | undefined>();

const show = computed({
    get() {
        return activityLogSubjectType.value && activityLogSubjectUuid.value;
    },
    set(value) {
        if (!value) {
            activityLogSubjectType.value = null;
            activityLogSubjectUuid.value = null;
        }
    },
});

const isDatetimeAttribute = (key: string) => {
    return (
        key.includes("_at") ||
        key.includes("_time") ||
        key.includes("date") ||
        [
            "arrive_destination_not_before",
            "arrive_destination_no_later_than",
            "depart_origin_not_before",
            "depart_origin_no_later_than",
        ].includes(key)
    );
};

const loadActivityLogs = () => {
    loading.value = true;
    let param: ListActivityLogsRequestParameters = {
        subject_type: activityLogSubjectType.value,
        subject_uuid: activityLogSubjectUuid.value,
        order_by: paginateParams.value.sortBy ?? 'created_at',
        order_direction: paginateParams.value.sortDirection ?? 'desc',
        amount: paginateParams.value.perPage,
        page: paginateParams.value.page,
        date_from: dateRange.value.from,
        date_to: dateRange.value.to,
        query: searchQuery.value,
    }

    ActivityLog.index(param)
        .then((response) => {
            activityLogs.value = response.data.data;
            paginatedMeta.value = response.data.meta as PaginatedMetaInterface;
        })
        .finally(() => {
            loading.value = false;
        });
};

const searchActivityLogs = () => {
    paginatedMeta.value.current_page = 1;
    paginateParams.value.page = 1;
    loadActivityLogs();
}

const toggleSort = (column: string) => {
    paginateParams.value.sortDirection =
        paginateParams.value.sortBy !== column
            ? sortDirectionEnum.Ascending
            : paginateParams.value.sortDirection === sortDirectionEnum.Ascending
                ? sortDirectionEnum.Descending
                : sortDirectionEnum.Ascending;

    paginateParams.value.sortBy = column;

    loadActivityLogs();
};

const selectedActivityLog: ComputedRef<ActivityLogResource | null | undefined> = computed(() => {
    if (!activityLogs.value) {
        return null;
    }
    return activityLogs.value.find((i) => i.id === propertiesModalActivityId.value);
});

watch(
    () => propertiesModalActivityId.value,
    (newValue) => {
        if (newValue && propertiesModal.value) {
            listModal.value?.hide();
            propertiesModal.value?.show();
        } else {
            listModal.value?.show();
            propertiesModal.value?.hide();
        }
    }
);

watch(
    () => show.value,
    (newValue) => {
        if (newValue) {
            loadActivityLogs();
            listModal.value?.show();
        } else {
            listModal.value?.hide();
            activityLogs.value = undefined;
        }
    }
);

onMounted(() => {
    let activityLogsModal = document.getElementById("activityLogsModal") as Element;
    let activityLogsPropertiesModal = document.getElementById("activityLogsPropertiesModal") as Element;

    listModal.value = new Modal(activityLogsModal);
    propertiesModal.value = new Modal(activityLogsPropertiesModal);

    activityLogsModal.addEventListener('hidden.bs.modal', () => {
        if (!propertiesModalActivityId.value) {
            show.value = false;
            searchQuery.value = undefined;
            activityLogs.value = undefined;
        }
    })

    activityLogsPropertiesModal.addEventListener('hidden.bs.modal', () => {
        propertiesModalActivityId.value = undefined;
    })
});
</script>
